export interface KpiRow {
  name: string;
  kpi: string;
  kpi_order: number | null;
}

export const DEFAULT_KPIS: KpiRow[] = [
  { name: 'kpi1', kpi: 'kpi1_filtered', kpi_order: 1 },
  { name: 'kpi2', kpi: 'kpi2_filtered', kpi_order: 2 },
  { name: 'kpi3', kpi: 'kpi3_filtered', kpi_order: 3 }
];
